export function getOrdinal(n) {
  const s = ["th", "st", "nd", "rd"], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

const months = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export function formatDate(dateStr) {
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;
  const day = getOrdinal(date.getDate());
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `${day} of ${month}, ${year} @ ${formatTime(date)}`;
}

export function formatTime(date) {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours %= 12;
  if (hours === 0) hours = 12;
  const minStr = minutes.toString().padStart(2, '0');
  return minutes === 0 ? `${hours}${ampm}` : `${hours}.${minStr}${ampm}`;
}

export function formatDateRange(startStr, endStr) {
  const start = new Date(startStr);
  const end = new Date(endStr);
  if (isNaN(start) || isNaN(end)) return formatDate(startStr);
  const startDay = getOrdinal(start.getDate());
  const endDay = getOrdinal(end.getDate());
  const startMonth = months[start.getMonth()];
  const endMonth = months[end.getMonth()];
  const startYear = start.getFullYear();
  const endYear = end.getFullYear();
  if (startYear === endYear) {
    if (startMonth === endMonth) {
      return `${startDay} to ${endDay} of ${startMonth}, ${startYear}`;
    }
    return `${startDay} of ${startMonth} to ${endDay} of ${endMonth}, ${startYear}`;
  }
  return `${startDay} of ${startMonth}, ${startYear} to ${endDay} of ${endMonth}, ${endYear}`;
}

export function displayEventDate(startStr, endStr) {
  const start = new Date(startStr);
  if (!endStr) return formatDate(startStr);
  const end = new Date(endStr);
  if (isNaN(start) || isNaN(end)) return formatDate(startStr);

  const boundary = new Date(start);
  boundary.setHours(8, 0, 0, 0);
  if (start < boundary) {
    boundary.setDate(boundary.getDate() - 1);
  }
  const endBoundary = new Date(boundary);
  endBoundary.setDate(boundary.getDate() + 1);

  if (end <= endBoundary) {
    const day = getOrdinal(start.getDate());
    const month = months[start.getMonth()];
    const year = start.getFullYear();
    return `${day} of ${month}, ${year} - ${formatTime(start)} to ${formatTime(end)}`;
  }
  return formatDateRange(startStr, endStr);
}
